import CareTeamSection from './CareTeamSection';

export default CareTeamSection;
